import { redirect } from "vike/abort";
import type { GuardAsync } from "vike/types";

export const guard: GuardAsync = (pageContext) => {
  const ctx = pageContext as unknown as {
    locale?: string;
    urlLogical?: string;
    urlPathname?: string;
  };
  const logicalPath = ctx.urlLogical ?? ctx.urlPathname;
  if (logicalPath !== "/download") return;

  const locale = ctx.locale;
  const prefix = locale && locale !== "en" ? `/${locale}` : "";
  throw redirect(`${prefix}/download/android`);
};
